import { Review } from '../interfaces/review';

export const reviews: Review[] = [
  {
    text: 'Concluí o curso Angular Moderno ministrado por Henrique Custódia na Code Dimension. Foi uma experiência extremamente enriquecedora, que me permitiu aprofundar conhecimentos e me atualizar com os recursos mais modernos do Angular 20, reforçando boas práticas para o desenvolvimento de aplicações web escaláveis, performáticas e de alta qualidade.',
    author: 'Flavio Milani',
    role: 'IT Engineering Analyst',
    avatar: '/images/reviewers/Flavio-Milani.jpg',
  },
  {
    text: `Curso excelente! O Henrique é um ótimo professor e demonstra grande domínio do conteúdo ensinado. O único ponto negativo é que o curso acaba! 😄 Em menos de duas semanas concluí todo o curso de Angular Moderno. O que mais me chamou a atenção foi a forma objetiva como o conteúdo foi apresentado. Tudo o que foi ensinado tinha um propósito claro e era aplicado diretamente no projeto, o que fez toda a diferença para mim. Na minha opinião, esse é o principal fator que diferencia um curso de qualidade de uma simples coleção de tutoriais: a construção prática de um projeto com contexto real, onde cada conceito aprendido tem uma aplicação concreta. Recomendo fortemente para quem deseja aprender Angular de forma estruturada, prática e eficiente.`,
    author: 'Felipe Padovani',
    role: 'Full Stack Engineer',
    avatar: '/images/reviewers/Felipe-Padovani.jpeg',
  },
  {
    text: 'Assisti todas as aulas do curso Angular Moderno até agora, a forma que o Henrique ensina é excelente. Já tenho alguma experiência com as versões mais antigas do Angular, mas mesmo assim, ainda aprendi novos conceitos. Massa demais, de verdade!',
    author: 'Caio Rocha',
    role: 'Front-end Developer | Angular | React',
    avatar: '/images/reviewers/Caio-Rocha.jpeg',
  },
  {
    text: 'Ficou muuuuuuito bom o conteúdo do curso, foi direto ao ponto, sem muito rodeio pra falar sobre um tópico específico, gostei demais! 🙂 Pequenos vídeos separadinhos com cada tema específico, top demais!',
    author: 'Leonardo Henrique',
    role: 'Desenvolvedor Front-End | Angular',
    avatar: '/images/reviewers/Leonardo-Henrique.jpeg',
  },
  {
    text: 'O curso de testes unitários da code é único no mercado, você não vai encontrar em lugar nenhum na língua portuguesa um curso tão completo sobre testes é realmente algo único. O Henrique o instrutor do curso tem uma didática excelente ele ensina e mostra os conceitos e ta sempre atualizado com as novidades do Angular e do universo de Desenvolvimento Web. Eu ja recomendei o curso para alguns colegas e devs do meu time.',
    author: 'Matheus Bento de Pereira',
    role: 'Senior Software Engineer - Tech Lead',
    avatar: '/images/reviewers/matheus-bento-de-pereira.jpeg',
  },
  {
    text: 'Quero agradecer pelo curso Testes Automatizados com Angular. Foi uma experiência excelente! O conteúdo é muito bem estruturado, direto ao ponto e aborda com profundidade os conceitos fundamentais. Eu já tinha experiência com Angular, mas testes sempre foram um desafio. Após o curso, consegui destravar diversos pontos, entendi melhor as boas práticas e agora me sinto muito mais seguro para escrever testes. Parabéns pelo ótimo trabalho, fez toda a diferença na minha trajetória!',
    author: 'Vitor Santos',
    role: 'Desenvolvedor de Software',
    avatar: '/images/reviewers/Vitor-Santos.jpeg',
  },
  {
    text: 'O professor Henrique demonstra excelente domínio do conteúdo e conduz as aulas com clareza e segurança. Sua experiência prática enriquece significativamente o curso, proporcionando aos alunos uma visão mais aplicada da teoria. Recomendo fortemente a aquisição do curso — certamente será uma experiência enriquecedora.',
    author: 'Farley Souza',
    role: 'Desenvolvedor Full Stack .NET',
    avatar: '/images/reviewers/Farley-Souza.jpeg',
  },
  {
    text: 'Curso de Testes Automatizados Com Angular: sem dúvida, foi o melhor material que já vi sobre o tema, especialmente em português. Recomendo fortemente. Mesmo já trabalhando com testes há mais de dois anos, o curso reforçou bastante as boas práticas e trouxe insights valiosos.',
    author: 'Adriano Dutra Magalhães',
    role: 'Desenvolvedor web | Angular | C#',
    avatar: '/images/reviewers/adriano-dutra-magalhaes.jpg',
  },
  {
    text: 'Curso de Angular Moderno: A mesma qualidade do curso de testes se repete aqui. Os conteúdos vão muito além do básico. Eles abordam problemas reais do dia a dia e mostram soluções que já existem no Angular, mas que muitos acabam não utilizando por falta de conhecimento. A entrega do Henrique está muito acima do esperado. Vale muito a pena!',
    author: 'Adriano Dutra Magalhães',
    role: 'Desenvolvedor web | Angular | C#',
    avatar: '/images/reviewers/adriano-dutra-magalhaes.jpg',
  },
  {
    text: 'O curso é maravilhoso, completo, com ele eu consegui construir uma boa base em testes unitários no Angular utilizando o jest, além disso, foi bem proveitoso.',
    author: 'Pedro Santiago',
    role: 'Front-End Developer',
    avatar: '/images/reviewers/pedro-santiago.jpeg',
  },
  {
    text: 'Estou gostando bastante do curso. A didática e os exemplos têm me ajudado a desenvolver essa habilidade no meu dia a dia. O conteúdo é completo e bem estruturado. Super recomendo!',
    author: 'Bruna Chagas',
    role: 'Front End Developer',
    avatar: '/images/reviewers/bruna-souza-chagas.jpeg',
  },
  {
    text: 'Muito bom aprender conteúdo avançado com profissionais de uma maneira muito didática. O conteúdo do curso já está sendo aplicado no meu trabalho, muito útil.',
    author: 'Bruno Anjos',
    role: 'Senior FullStack Engineer',
    avatar: '/images/reviewers/Bruno-Anjos.jpg',
  },
  {
    text: 'Se você quer saber todos os segredos dos testes, do TDD e do end-to-end com uma metodologia tranquila e bem minuciosa façam esse curso. Estou gostando muito!',
    author: 'Luciana Moura Rodrigues',
    role: 'Front-end Developer',
    avatar: '/images/reviewers/Luciana-Moura-Rodrigues.jpg',
  },
  {
    text: 'Acho que o curso de testes automatizados com Angular está fantástico pois é difícil encontrar cursos sobre testes com Angular junto com TDD.',
    author: 'Flavio Milani',
    role: 'IT Engineering Analyst',
    avatar: '/images/reviewers/Flavio-Milani.jpg',
  },
  {
    text: 'Curso Angular Moderno foi uma experiência sensacional! Agregou muito, valeu a pena o investimento. Com os conteúdos dá pra adquirir conhecimento mais que suficiente pra partir para o campo de batalha, que é onde a evolução acontece de forma mais notória. Muito show, parabéns!',
    author: 'Eduardo Bertozi',
    role: 'Desenvolvedor Backend | Nestjs | Angular',
    avatar: '/images/reviewers/Eduardo-Bertozi.jpeg',
  },
  {
    text: 'E pra encerrar esse ano incrível, eu finalizei a Qualificação em Angular Moderno do Henrique Custódia da Code Dimension. Sensacional todo o conteúdo, indico bastante pra quem já possui um conhecimento na ferramenta e deseja se atualizar sobre os recursos do Angular 20, entre eles Signals, Resources, Defer Blocks e etc.',
    author: 'Leonardo Faria',
    avatar: '/images/reviewers/leonardo-faria.jpeg',
    role: 'Future Software Engineer- Studying Computer Science at UENP',
  },
  {
    text: 'Concluí o curso de Testes Automaizados com Angular! Testes não são um detalhe, são parte essencial de um software bem construído, sólido e escalável. Fica aqui o meu agradecimento ao Henrique Custódia pelos ensinamentos e pela didática ao longo do curso. Seguimos evoluindo para entregar não apenas código, mas software com qualidade e confiabilidade!',
    author: 'Gabriel Emilio',
    role: 'Desenvolvedor Front-end | Angular & React',
    avatar: '/images/reviewers/Gabriel-Emilio.jpeg',
  },
];
